import React from 'react'
import SAISVG from '../../../../../../_template/helpers/CommonFunction'
import { getShortForm, timeZoneDateFormat } from '../../../../../component/common/Helper';
const DemoRequestDataList = (props) => {
    const {demoRequest} = props;
    let purposeHtml = '';
    if(demoRequest.purpose.length > 0){
        purposeHtml = demoRequest.purpose.map((purposeData, index) => (
            <span className="badge badge-light-dark fs-7 fw-bold text-gray-600 mb-2" key={index}>
                <span className="text-gray-600 fw-bold fs-6">{purposeData}</span>
            </span>
        ))
    }

    let channelHtml = '';
    if(demoRequest.channel.length > 0){
        channelHtml = demoRequest.channel.map((channelData, index) => (
            <span className="badge badge-light-dark fs-7 fw-bold text-gray-600 mb-2" key={index}>
                <span className="text-gray-600 fw-bold fs-6">{channelData}</span>
            </span>
        ))
    }



    return (
        <>
            <tr className="">
                <td className="d-flex align-items-center border-none">
                    <div className="symbol rounded symbol-50px overflow-hidden me-3">
                        <a>
                            <div className="symbol-label fs-3 bg-light-dark text-dark fw-bold text-uppercase">
                                {getShortForm(demoRequest.name)}
                            </div>
                        </a>
                    </div>
                    <div className="d-flex flex-column">
                        <a className="text-gray-800  mb-1">
                            {demoRequest.name}
                        </a>
                        <span>
                            <div className="badge badge-light-dark fw-bold">
                                {demoRequest.email}
                            </div>
                        </span>
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {demoRequest.phone_no}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {demoRequest.landline_no}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {demoRequest.organization}
                    </div>
                </td>
                <td>
                    {purposeHtml}
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {demoRequest.messages}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {channelHtml}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {demoRequest.volume}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {demoRequest.crm_name}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {timeZoneDateFormat(demoRequest.created_at)}
                    </div>
                </td>
                <td>
                    <button 
                        className="btn btn-sm btn-icon btn-light-danger px-4"
                        onClick={() =>  props.demoRequestDelete(demoRequest.id)}
                    >
                        <SAISVG path="media/icons/duotune/general/gen027.svg" className="svg-icon-muted svg-icon-2" />
                    </button>
                </td>
            </tr>
        </>
    )
}

export default DemoRequestDataList